import { useQuery, UseQueryOptions } from 'react-query';

import type { Playlist } from '@24i/nxg-sdk-photon';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';

import { queryKeys } from '../queryKeys';

const useMyRentalsQuery = (options?: UseQueryOptions<Playlist>) => {
    const { fetchMyRentals } = usePurchaseData();

    return useQuery<Playlist>(queryKeys.myRentals, fetchMyRentals, {
        ...options,
    });
};

export default useMyRentalsQuery;
